import { render, staticRenderFns } from "./centerrscreen-loading.vue?vue&type=template&id=4b74eaa8&scoped=true&"
import script from "./centerrscreen-loading.vue?vue&type=script&lang=js&"
export * from "./centerrscreen-loading.vue?vue&type=script&lang=js&"
import style0 from "./centerrscreen-loading.vue?vue&type=style&index=0&id=4b74eaa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b74eaa8",
  null
  
)

export default component.exports